module.exports = __webpack_public_path__ + "img/Profil_CS-Multiliner_Mix.fd684188.jpg";